import { useTranslation } from 'react-i18next';

export function ChartEmptyState() {
  const { t } = useTranslation();
  return (
    <div className="h-full min-h-[160px] flex items-center justify-center text-[12px] text-slate-400">
      {t('reporting.no_data')}
    </div>
  );
}
